import Button from '@ixigo/iui/Button';
import { FC, useState } from 'react';
import { useConversation } from '../../contexts/conversation';
import { ActorType } from '../../enums/conversation';
import CheckboxList from '../CheckboxList';
import { CheckboxListProps } from '../CheckboxList/index.types';
import MessageBubble from '../MessageBubble';
import { InputSelectConfig } from './index.types';

const MultiselectInput: FC = () => {
    const { input, sendMessage } = useConversation();
    const [value, setValue] = useState<CheckboxListProps['data']>();
    const { optionList, submitBtnLabel, required } = input!.config as InputSelectConfig;

    const onSubmit = () => {
        const messageParts = [
            {
                isPrivate: false,
                text: {
                    content: value?.map((item) => item.label).join(', ') || '',
                },
            },
        ];

        sendMessage({ messageParts, input: value });
    };

    return (
        <>
            <MessageBubble actor={{ type: ActorType.BOT }} className='mr-40 ml-20'>
                <CheckboxList data={optionList} onChange={setValue} />
            </MessageBubble>
            <div className='mr-40 ml-20'>
                <Button
                    className='!px-20 !py-[8px]'
                    variant='outlined'
                    onClick={onSubmit}
                    disabled={required && !value?.length}
                >
                    {submitBtnLabel || 'Submit'}
                </Button>
            </div>
        </>
    );
};

export default MultiselectInput;
